import styled from 'styled-components';
import { AppStyledProps } from '../../../../../types';
import { Props } from './types';
import { hexToRgb } from '@/components/util';

type T = Props & AppStyledProps;

export const RootStyled = styled.div<T>`
  position: absolute;
  width: 200px;
  top: 210px;
  right: 50px;
  z-index: 110;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(15px);
  border-radius: 15px;
  padding: 0.5em 0;
  color: white;
  font-size: 16px;
  font-family: Roboto;

  ${({ background, opacity, color, customTop, theme }) => {
    let styles = '';
    if (background && opacity) {
      const { r, g, b } = hexToRgb(background);
      styles += `background-color: rgba(${r},${g},${b}, ${opacity});`;
    }
    if (color) {
      styles += `color: ${color};`;
    }
    if (theme.device.mobile) {
      styles += '';
    }
    if (customTop) {
      styles += `top: ${customTop};`;
    }
    return styles;
  }}
`;
